import React, {forwardRef} from 'react'
import FJButton from "fj-components/FJButton";
import styles from './FJToolbarButton.module.less'
import classNames from 'classnames'

function FJToolbarButton(props, ref) {

  let {
    onClick,
    style,
    icon,
    disabled,
    text,
    active,
  } = props;
  return (
    <FJButton onClick={onClick}
              ref={ref}
              style={style}
              icon={icon}
              className={classNames(styles.button, {[styles.active]: active, [styles.disabled]: disabled})}
              textClass={styles.text}
              text={text}
							iconClass={styles.icon_class}
    />
  );
}

export default forwardRef(FJToolbarButton);
